import React from "react";
import LayOut from "../../components/LayOut";

const DeleteClient = () => {
  return (
    <LayOut>
      <div>Delete Client</div>
    </LayOut>
  );
};

export default DeleteClient;
